<script>
  export let visible;
</script>

<div id="modal" style="
  opacity: {visible? 1 : 0};
  visibility: {visible? 'visible' : 'hidden'};"
>
  <div id="modal-content">
    <button style="position: absolute; top: 0; right: 0; background-color: transparent; color: #666;" class='pure-button' on:click={()=>{visible = false}}>
      &#x2715;
    </button>
    <slot></slot>
  </div>
  <div id="overlay" on:click={() => {visible = false}}></div>
</div>

<style>
  #modal {
    left: 0;
    top: 0;
    position: fixed;
    width: 100%;
    height: 100%;
    transition: all .4s ease-in-out;
    -moz-transition: all .4s ease-in-out;
    -webkit-transition: all .4s ease-in-out;
    z-index: 101;
  }
  #modal-content {
    position: fixed;
    max-height: 90%;
    width: 90%;
    z-index: 120;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 5px;
    background-color: var(--background);
    text-align: center;
    box-shadow: 0 3px 7px rgba(0,0,0,.25);
    box-sizing: border-box;
    padding: 20px;
  }
  #overlay {
    background-color: #000;
    background: rgba(0,0,0,.8);
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 110;
  }
  @media (min-width: 800px) {
    #modal-content {
      width: 65%;
      padding: 30px;
    }
  }
</style>